import script from "./LeaveType.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveType.vue?vue&type=script&setup=true&lang=js"

import "./LeaveType.vue?vue&type=style&index=0&id=19178074&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19178074"]])

export default __exports__